<div class="feedback-container" [ngClass]="waitingReview ? 'waiting-review' : ''">
  <mat-expansion-panel
  [disabled]="waitingReview"
  (closed)="panelOpenState = false"
  (opened)="panelOpenState = true"
  [expanded]="panelOpenState"
  hideToggle>
  <mat-expansion-panel-header (click)="$event.stopPropagation()">
    <mat-panel-title>
      <mat-icon class="icon-s feedback-icon">announcement</mat-icon>
      <div class="feedback-title">
        <span class="body-s-bold">User feedback:</span>
        <section class="stars-container">
          @for(index of [1, 2, 3, 4, 5]; track index) {
            <mat-icon class="star-icon icon-s">{{isStarActive(index) ? 'star' : 'star_border'}}</mat-icon>
          }
        </section>
      </div>
    </mat-panel-title>
    @if(!waitingReview) {
      <mat-icon class="expansion-panel-icon">
        {{ !panelOpenState ? 'arrow_drop_down' : 'arrow_drop_up' }}
      </mat-icon>
    }
  </mat-expansion-panel-header>
    <p class="body-m">{{ comment }}</p>
    <span class="body-s text-dark-alt">{{ createdAt | date : 'dd/MM/yyyy - HH:mm' }}</span>
    @if(waitingReview) {
      <app-button size="small" type="secondary" text="Mark as reviewed" iconPosition="left" icon="check" (click)="markAsReviewed()"></app-button>
    }
</mat-expansion-panel>
</div>
